import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import { LIGHT_THEME } from '@rsos/theme/constants';
import { getAppName } from '@rsos/utils/metaTags';

const feAppName = getAppName();

/**
 * Create a logged-in user object used for TalkJS authentication
 */
const useTF911LoggedInUser = () => {
  const themeName = useSelectedTheme();

  const role = useMemo(
    () =>
      themeName === LIGHT_THEME
        ? 'rsp_tf911_light_user'
        : 'rsp_tf911_dark_user',
    [themeName],
  );

  const profile = useSelector(state => state.sinatra.user.profile);

  const currentPSAPDisplayName = useSelector(
    state => state.psaps.currentPSAP.display_name,
  );

  const loggedInUser = useMemo(() => {
    const {
      id = '',
      first_name = '',
      last_name = '',
      email = null,
      talkjs_signature = '',
    } = profile;

    return {
      id: id ? parseInt(id) : '',
      name: `${first_name} ${last_name}`.trim(),
      email: email,
      signature: talkjs_signature,
      custom: {
        org_name: currentPSAPDisplayName || '',
        feAppName,
      },
      ...(role ? { role } : {}),
    };
  }, [currentPSAPDisplayName, profile, role]);

  return loggedInUser;
};

export default useTF911LoggedInUser;
